import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

interface ExerciseData {
  muscle_group: string;
  exercise_count: number;
}

interface ExercisesPieChartProps {
  data: ExerciseData[];
}

const ExercisesPieChart: React.FC<ExercisesPieChartProps> = ({ data }) => {
  // Цвета для разных групп мышц (более тусклые)
  const COLORS = [
    '#60a5fa', // тусклый синий
    '#f87171', // тусклый красный
    '#34d399', // тусклый зеленый
    '#fbbf24', // тусклый оранжевый
    '#a78bfa', // тусклый фиолетовый
    '#22d3ee', // тусклый голубой
    '#a3e635', // тусклый лаймовый
    '#fb923c', // тусклый оранжевый
    '#f472b6', // тусклый розовый
    '#818cf8', // тусклый индиго
  ];

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      
      return (
        <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
          <p className="font-medium text-gray-900">{data.muscle_group}</p>
          <p className="text-blue-600">
            Упражнений: <span className="font-semibold">{data.exercise_count}</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="mb-2">
        <h3 className="text-lg font-semibold text-gray-900 mb-1">Распределение упражнений</h3>
        <div className="flex flex-wrap gap-4 text-sm text-gray-600">
          <span>Групп мышц: {data.length}</span>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ muscle_group }) => `${muscle_group}`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="exercise_count"
            nameKey="muscle_group"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ExercisesPieChart; 